export const SCENES = [
    {
        id: "village",
        act: "Chapter one",
        title: "The village",
        p: 0.03,
        caption: "My story begins in a small village in Uttar Pradesh.",
        narration:
            "Namaste. I'm a developer from a small village in Uttar Pradesh, and this is my story. It begins among mustard fields, mango trees, and a lot of questions.",
    },
    {
        id: "school",
        act: "Chapter two",
        title: "School days",
        p: 0.2,
        caption: "A perfectly ordinary student — endlessly curious about computers.",
        narration:
            "In my village school, I was a perfectly ordinary student. Decent marks, decent cricket. But computers fascinated me. I kept wondering how the world inside a screen actually works.",
    },
    {
        id: "flight",
        act: "Chapter three",
        title: "The flight",
        p: 0.4,
        caption: "Then I flew — UP to Bengaluru.",
        narration:
            "Then I flew. From my village in Uttar Pradesh, all the way down to Bengaluru, Karnataka. Hundreds of kilometres from everything familiar.",
    },
    {
        id: "college",
        act: "Chapter four",
        title: "College years",
        p: 0.58,
        caption: "Average at code. Stubborn at learning.",
        narration:
            "College in Bengaluru. Let me be honest: I was never a coding genius. Just average, but stubborn. I kept showing up, kept learning, kept building.",
    },
    {
        id: "return",
        act: "Chapter five",
        title: "The call home",
        p: 0.74,
        caption: "Money got tight. Family first — I came back.",
        narration:
            "Then money got tight at home. So I came back to my village. Family first. It was the hardest decision I've made, and I stand by it.",
    },
    {
        id: "dawn",
        act: "Chapter six",
        title: "Rebuilding",
        p: 0.87,
        caption: "Freelancing, learning with AI, rebuilding daily.",
        narration:
            "Back home, I kept going. Freelancing on small projects, learning with AI tools, experimenting every day. Constraints made me resourceful.",
    },
    {
        id: "projects",
        act: "Chapter seven",
        title: "Recent builds",
        p: 0.96,
        caption: "Crafted Space, Pacepivot, Fiverr — and my inbox, one click away.",
        narration:
            "And here is my work so far. A full-stack website I built and shipped, Crafted Space dot shop. Pacepivot, an Amazon FBA operations project. My freelance gigs on Fiverr. And my inbox is always open — one click away.",
    },
];

export const ACT_BOUNDS = [0, 0.14, 0.32, 0.5, 0.66, 0.8, 0.93, 1.001];

export const LINKS = {
    craftedspaces: "https://craftedspace.shop",
    fiverr: "https://www.fiverr.com/arpits001",
    pacepivot: "https://pacepivot.com",
    linkedin: "https://www.linkedin.com/in/arpit-shukla",
};

export const EMAIL = "arpits.connect@gmail.com";
